module.exports = __webpack_public_path__ + "static/media/YB5F04_2.235e51d4.jpg";